import { v4 as uuidv4 } from 'uuid';

import React, {createContext, useReducer, useEffect} from 'react'
import axiosClient from '../utils/API'
import swal from 'sweetalert'
import productList from '../components/productList'

export const ContextApp = createContext()

const StateApp = ({children}) => {
  const reducer = (state, action) => {
    switch (action.type) {
      case 'CANCEL_LOADING_SPINNER':
        return {
          ...state,
          cancelSpinner: true
        }
      case 'GET_PRODUCTS_OKAY':
        return {
          ...state,
          products: action.payload,
        }
      case 'GET_PRODUCTS_DISCOUNT_OKAY':
        return {
          ...state,
          productsDiscount: action.payload,
        }
      case 'GET_PRODUCTS_FREEDELIVERY_OKAY':
        return {
          ...state,
          productsFreeDelivery: action.payload,
        }

      case 'GET_CATEGORIES_OKAY':
        return {
          ...state,
          categories: action.payload,
        }
      case 'GET_PRODUCTS_BY_CATEGORY_OKAY':
        return {
          ...state,
          productsByCategory: action.payload,
          parametersView: action.option,
        }
      case 'GET_PRODUCT_BY_ID_OKAY':
        return {
          ...state,
          singleProduct: action.payload,
        }
      case 'GET_IMAGES_OF_PRODUCT':
        return {
          ...state,
          singleProductsImages: action.payload
        }
      case 'GET_PRODUCTS_RELATED_OKAY':
        return {
          ...state,
          productsRelatedFromOne: action.payload
        }
      case 'ADD_PRODUCT_TO_CAR_SHOPPING':
        return {
          ...state,
          carShopping: [...state.carShopping, action.payload],
        }

      case 'INCREMENT_ONE_PRODUCT':
        return {
          ...state,
          carShopping:action.payload
        }

      case 'DELETE_PRODUCT_CAR_SHOPPING':
        return {
          ...state,
          carShopping: state.carShopping.filter(
            product => product.id !== action.payload,
          ),
        }
      case 'GET_USER_INFORMATION_OKAY':
        return {
          ...state,
          user: action.payload,
        }
      case 'GET_DEPARMENTS_OKAY':
        return {
          ...state,
          deparments: action.payload,
        }

      case 'GET_PRODUCTS_BY_SEARCH':
        return {
          ...state,
          productsBySearch: action.payload,
          searchDone: true,
          searchError:false,
        }

      case 'GET_PRODUCTS_BY_SEARCH_ERROR':
        return {
          ...state,
          searchDone: true,
          searchError: true
        }
      case 'CLOSE_CATEGORY_BAR':
        return {
          ...state,
          categoryListShow: false,
        }

      case 'OPEN_CATEGORY_BAR':
        return {
          ...state,
          categoryListShow: true,
        }
      case 'GET_ORDEN_OKAY_PAYMENT':
        return {
          ...state,
          orderCreated: action.payload,
          redirectSuccess: true,
        }
      case 'CLEAN_CAR_ALL':
        return {
          ...state,
          carShopping: [],
          redirectSuccess: false,
        }
      case 'GET_DELIVERY_INFO_OKAY':
        return {
          ...state,
          deliveryInfo: action.payload,
        }
      case 'SIGN_OUT_SESSION':
        return {
          ...state,
          user: {},
        }

      case 'CLEAN_DELIVERY_INFO':
        return {
          ...state,
          deliveryInfo: [],
        }
      case 'GET_ORDEN_ERROR_CARD':
        return {
          ...state,
          errorCardPaymentMsg: action.payload,
        }
      case 'RESET_ERROR_CARD_MSG':
        return {
          ...state,
          errorCardPaymentMsg: null,
        }

      case 'RESET_SEARCH_PRODUCS':
        return {
          ...state,
          searchDone: false,
          searchError: false,
          productsBySearch: []
        }

      case 'RESET_RELOAD_PRODUCTS_LIST':
        return {
          ...state,
          reloadProductsByCategory: true,
          productsByCategory: [],
        }
      case 'RESET_FALSE_RELOAD_PRODUCTS_BY_CATEGORY':
        return {
          ...state,
          reloadProductsByCategory: false,
        }

      case 'GET_PRODUCTS_BY_PROVIDER_OKAY':
        return {
          ...state,
          productsByProvider: action.payload,
          provider_name: action.payload[0].batches?.provider?.name,
        }
      case 'GET_PRODUCTS_BY_PROVIDERS_OKAY':
        return {
          ...state,
          productsByProvider: action.payload,
          provider_name: action.option,
        }

      case 'CLEAN_PRODUCTS_BY_PROVIDER':
        return {
          ...state,
          productsByProvider: [],
          products_not_found: false,
        }

      case 'GET_PRODUCTS_BY_PROVIDER_AND_CATEGORY':
        return {
          ...state,
          productsByProvider: action.payload,
          products_not_found: false,
        }

      case 'GET_PRODUCTS_BY_PROVIDER_AND_CATEGORY_EMPTY':
        return {
          ...state,
          products_not_found: true,
        }

      case 'CLEAN_NAME_PROVIDER':
        return {
          ...state,
          provider_name: null,
        }

      case 'GET_PRODUCTS_TO_SHOW_IN_HOME_OKAY':
        return {
          ...state,
          productsToShowInHome: action.payload,
        }
      case 'GET_PRODUCTS_TO_SHOW_IN_HOME_OKAY2':
        return {
          ...state,
          productsToShowInHome2: action.payload,
        }
      case 'GET_PRODUCTS_TO_SHOW_IN_HOME_OKAY3':
        return {
          ...state,
          productsToShowInHome3: action.payload,
        }
      case 'GET_PRODUCTS_TO_SHOW_IN_HOME_TEC_OKAY':
        return {
          ...state,
          productsToShowInHomeTec: action.payload,
        }
      case 'GET_PRODUCTS_TO_SHOW_IN_HOME_BEL_OKAY':
        return {
          ...state,
          productsToShowInHomeBel: action.payload,
        }
      case 'GET_PRODUCTS_TO_SHOW_IN_HOME_MOD_OKAY':
        return {
          ...state,
          productsToShowInHomeMod: action.payload,
        }
      case 'GET_PRODUCTS_TO_SHOW_IN_HOME_HOG_OKAY':
        return {
          ...state,
          productsToShowInHomeHog: action.payload,
        }
      case 'GET_SUB_CATEGORIES_OKAY':
        return {
          ...state,
          subCategoriesList: action.payload,
        }

      case 'CLEAN_PRODUCTS_BY_SUB_CATEGORY':
        return {
          ...state,
          subCategoriesList: [],
        }

      case 'GET_PRODUCTS_BY_SUB_CATEGORY_OKAY':
        return {
          ...state,
          productsBySubCategory: action.payload,
          parametersView: action.option,
          searchDone: true,
        }

      case 'GET_CONTADOR_CATEGORIAS':
        return {
          ...state,
          contador: action.payload,
        }
      case 'GET_ADDRESS_OKAY':
        return {
          ...state,
          userAddress: action.payload,
        }
      case 'CLEAN_ADDRESS':
        return {
          ...state,
          userAddress: [],
        }
      case 'GET_ID_ADDRESS_GENERATED':
        return {
          ...state,
          idAddressGenerated: action.payload,
        }
      case 'CLEAN_ID_ADDRESS_GENERATED':
        return {
          ...state,
          idAddressGenerated: 0,
        }
      case 'GET_PROVIDERS_TO_SHOW_IN_HOME_OKAY':
        return {
          ...state,
          topProviders: action.payload,
        }
      case 'GET_ALL_PROVIDERS_OKAY':
        return {
          ...state,
          allProviders: action.payload,
        }
      case 'GET_PAGINATE_COUNT':
        return {
          ...state,
          paginateCount: action.payload,
        }
      case 'CLEAN_PAGINATE_COUNT':
        return {
          ...state,
          paginateCount: 0,
        }
      case 'GET_LOAD':
        return {
          ...state,
          loading: true,
        }
      case 'CLEAR_LOAD':
        return {
          ...state,
          loading: false,
        }
      case 'GET_COUNT_PRODUCT':
        return {
          ...state,
          countProduct: action.payload,
        }
      case 'CLEAR_COUNT_PRODUCT':
        return {
          ...state,
          countProduct: 0,
        }
      case 'RESET_RELOAD_PRODUCTS_SUB_LIST':
        return {
          ...state,
          productsBySubCategory: [],
        }
      default:
        return state
    }
  }

  const initialState = {
    paginate: 25,
    paginateCount: 0,
    contador: [],
    products: [],
    productsDiscount: [],
    productsFreeDelivery: [],
    categories: [],
    productsByCategory: [],
    productsBySearch: [],
    topProviders: [],
    singleProduct: {},
    carShopping: [],
    user: {},
    deparments: [],
    categoryListShow: true,
    orderCreated: {},
    redirectSuccess: false,
    deliveryInfo: [],
    errorCardPaymentMsg: null,
    searchDone: false,
    searchError:false,
    reloadProductsByCategory: true,
    productsByProvider: [],
    provider_name: null,
    products_not_found: false,
    productsToShowInHome: [],
    productsToShowInHome2: [],
    productsToShowInHome3: [],
    productsToShowInHomeTec: [],
    productsToShowInHomeBel: [],
    productsToShowInHomeMod: [],
    productsToShowInHomeHog: [],
    subCategoriesList: [],
    productsBySubCategory: [],
    parametersView: [],
    userAddress: [],
    userAddr: [],
    allProviders: [],
    idAddressGenerated: 0,
    loading: false,
    countProduct: 0,
    productsRelatedFromOne: [],
    singleProductsImages: null,
    cancelSpinner: false
  }

  const [state, dispatch] = useReducer(reducer, initialState)

  const {user, products, deparments, carShopping, deliveryInfo} = state

  useEffect(() => {
    getCategories()
    getDeparments()
    // getProductsToShowInHome()
    //getProductsDiscount()
    //getProductsDiscountv2()
    //getProducts()
    //initContador()
  }, [])

  const getProductsToShowInHome = async () => {
    try {
      const productDestacados = await axiosClient.get(
        '/categories?filter=[{"method":"where","parameters":["id",135]},{"method":"with","parameters":["products.batches","products.batches.provider","products.batches.distributor", "subcategories", "subcategories.products","subcategories.products.batches","subcategories.products.batches.provider","subcategories.products.batches.distributor","products.campaing"]},{"method":"orderby","parameters":["priority","desc"]}]',
      )
      const productDestacadosF = productDestacados.data[0].products.filter(
        product => product.batches.length > 0,
      )
      //const productDestacadosF = productDestacados.data[0].products.filter((product) => product.batches.length > 0 && product.batches[0].stock !== 0)

      dispatch({
        type: 'GET_PRODUCTS_TO_SHOW_IN_HOME_OKAY',
        payload: productDestacadosF,
      })

      const productVendidos = await axiosClient.get(
        '/categories?filter=[{"method":"where","parameters":["id",136]},{"method":"with","parameters":["products.batches","products.batches.provider","products.batches.distributor", "subcategories", "subcategories.products","subcategories.products.batches","subcategories.products.batches.provider","subcategories.products.batches.distributor","products.campaing"]},{"method":"orderby","parameters":["priority","desc"]}]',
      )
      const productVendidosF = productVendidos.data[0].products.filter(
        product => product.batches.length > 0,
      )
      //const productVendidosF =  productVendidos.data[0].products.filter((product) => product.batches.length > 0 && product.batches[0].stock !== 0)

      dispatch({
        type: 'GET_PRODUCTS_TO_SHOW_IN_HOME_OKAY2',
        payload: productVendidosF,
      })

      const productBuscados = await axiosClient.get(
        '/categories?filter=[{"method":"where","parameters":["id",137]},{"method":"with","parameters":["products.batches","products.batches.provider","products.batches.distributor", "subcategories", "subcategories.products","subcategories.products.batches","subcategories.products.batches.provider","subcategories.products.batches.distributor","products.campaing"]},{"method":"orderby","parameters":["priority","desc"]}]',
      )
      const productBuscadosF = productBuscados.data[0].products.filter(
        product => product.batches.length > 0,
      )
      //const productBuscadosF =  productBuscados.data[0].products.filter((product) => product.batches.length > 0 && product.batches[0].stock !== 0)

      dispatch({
        type: 'GET_PRODUCTS_TO_SHOW_IN_HOME_OKAY3',
        payload: productBuscadosF,
      })

      const TopProviders = await axiosClient.get(
        'providers?filter=[{"method":"where","parameters":["visible",1]},{"method":"orderby","parameters":["id","desc"]},{"method":"with","parameters":["batches"]},{"method":"paginate","parameters":["25"]}]',
      )
      const finalTopProviders = TopProviders.data.filter(
        product => (product.batches.length > 0) & (product.visible == 1),
      )
      //const finalTopDescTec2 = finalTopProviders.filter((product) => product.batches[0].length > 0 )

      //console.log("En context", finalTopProviders);

      dispatch({
        type: 'GET_PROVIDERS_TO_SHOW_IN_HOME_OKAY',
        payload: finalTopProviders,
      })

      //const TopDescTec = await axiosClient.get('/products_tecnologia')
      const TopDescTec = await axiosClient.get(
        'products?filter=[{"method":"orderby","parameters":["id","desc"]},{"method":"with","parameters":["batches","batches.provider","batches.distributor","campaing"]},{"method":"join","parameters":["category_product","category_product.product_id","=","products.id"]},{"method":"whereIn","parameters":["category_product.category_id",[10]]},{"method":"paginate","parameters":["50"]}]',
      )
      console.log(TopDescTec);
      const finalTopDescTec = TopDescTec.data.filter(
        product => product.batches.length > 0,
      )

      dispatch({
        type: 'GET_PRODUCTS_TO_SHOW_IN_HOME_TEC_OKAY',
        payload: finalTopDescTec,
      })

      //const TopDescBel = await axiosClient.get('/products_belleza')
      const TopDescBel = await axiosClient.get(
        'products?filter=[{"method":"orderby","parameters":["id","desc"]},{"method":"with","parameters":["batches","batches.provider","batches.distributor","campaing"]},{"method":"join","parameters":["category_product","category_product.product_id","=","products.id"]},{"method":"whereIn","parameters":["category_product.category_id",[44]]},{"method":"paginate","parameters":["8"]}]',
      )
      const finalTopDescBel = TopDescBel.data.filter(
        product => product.batches.length > 0,
      )
      //const finalTopDescBel = TopDescBel.data.filter((product) => product.batches.length > 0 && product.batches[0].stock !== 0)

      dispatch({
        type: 'GET_PRODUCTS_TO_SHOW_IN_HOME_BEL_OKAY',
        payload: finalTopDescBel,
      })

      //const TopDescMod = await axiosClient.get('/products_moda')
      const TopDescMod = await axiosClient.get(
        'products?filter=[{"method":"orderby","parameters":["id","desc"]},{"method":"with","parameters":["batches","batches.provider","batches.distributor","campaing"]},{"method":"join","parameters":["category_product","category_product.product_id","=","products.id"]},{"method":"whereIn","parameters":["category_product.category_id",[47]]},{"method":"paginate","parameters":["8"]}]',
      )
      const finalTopDescMod = TopDescMod.data.filter(
        product => product.batches.length > 0,
      )
      //const finalTopDescMod = TopDescMod.data.filter((product) => product.batches.length > 0 && product.batches[0].stock !== 0)

      dispatch({
        type: 'GET_PRODUCTS_TO_SHOW_IN_HOME_MOD_OKAY',
        payload: finalTopDescMod,
      })

      //const TopDescHog = await axiosClient.get('/products_hogar')
      const TopDescHog = await axiosClient.get(
        'products?filter=[{"method":"orderby","parameters":["id","desc"]},{"method":"with","parameters":["batches","batches.provider","batches.distributor","campaing"]},{"method":"join","parameters":["category_product","category_product.product_id","=","products.id"]},{"method":"whereIn","parameters":["category_product.category_id",[62]]},{"method":"paginate","parameters":["8"]}]',
      )
      const finalTopDescHog = TopDescHog.data.filter(
        product => product.batches.length > 0,
      )
      //const finalTopDescHog = TopDescHog.data.filter((product) => product.batches.length > 0 && product.batches[0].stock !== 0)

      dispatch({
        type: 'GET_PRODUCTS_TO_SHOW_IN_HOME_HOG_OKAY',
        payload: finalTopDescHog,
      })
    } catch (error) {
      console.log(error.response)
    }
  }

  const cleanCarShoppingAll = () => {
    dispatch({
      type: 'CLEAN_CAR_ALL',
    })
  }

  const saveAddresses = async (
    addresses,
    methodPayment,
    couponValid,
    idAddress,
    cardInfo,
  ) => {
    const {token} = user

    const {
      cardName,
      cardNumber,
      cvv_card,
      expiration_card_year,
      expiration_month,
    } = cardInfo

    const items = carShopping.map(product => {
      const id = product.batches[0].id
      let item = {
        quantity: product.cantidadCli,
        batch_id: id,
      }
      return item
    })

    try {
      /*const response = await axiosClient.post('/addresses', addresses, {
                    headers: {
                        "Authorization": `Bearer ${token}`
                    }
                })

                const { id } = response.data

                */

      let id

      //Validando si es direccion nueva o si es antigua
      if (idAddress == -99) {
        const response = await axiosClient.post('/addresses', addresses, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        id = response.data.id
        idAddress = response.data.id
      } else {
        id = idAddress
      }

      let coupon = null
      if (couponValid.code.length > 0) {
        const responseCouponVeri = await axiosClient.post(
          '/active-coupons',
          couponValid,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          },
        )

        coupon = {
          code: responseCouponVeri.data.code,
          coupon_id: responseCouponVeri.data.coupon_id,
          name: responseCouponVeri.data.name,
          discount: responseCouponVeri.data.discount,
        }
      }

      let orden = null

      if (methodPayment == 'Tarjeta') {
        if (coupon == null) {
          orden = {
            items,
            address_id: id,
            source: methodPayment,
            card: {
              name: cardName,
              number: cardNumber,
              cvv: cvv_card,
              expiration_year: expiration_card_year,
              expiration_month: expiration_month,
            },
          }
        } else {
          orden = {
            items,
            address_id: id,
            source: methodPayment,
            coupon,
            card: {
              name: cardName,
              number: cardNumber,
              cvv: cvv_card,
              expiration_year: expiration_card_year,
              expiration_month: expiration_month,
            },
          }
        }
      } else {
        if (coupon == null) {
          orden = {
            items,
            address_id: id,
            source: methodPayment,
          }
        } else {
          orden = {
            items,
            address_id: id,
            source: methodPayment,
            coupon,
          }
        }
      }

      const responseChecked = await axiosClient.post('/checked-order', orden, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })

      dispatch({
        type: 'GET_DELIVERY_INFO_OKAY',
        payload: responseChecked.data,
      })

      dispatch({
        type: 'CLEAN_ADDRESS',
      })

      dispatch({
        type: 'GET_ID_ADDRESS_GENERATED',
        payload: id,
      })

      getAddress(user)
    } catch (error) {
      console.log(error.response)
      dispatch({type: 'CANCEL_LOADING_SPINNER'})
      swal('Hubo un problema en el servidor.', '', 'error')
    }
  }

  const createOrderFinally = async couponValid => {
    const {token} = user
    const addresess_id = deliveryInfo[0].address_id
    const id = 0

    const items = carShopping.map(product => {
      const id = product.batches[0].id
      let item = {
        quantity: product.cantidadCli,
        batch_id: id,
      }
      return item
    })

    try {
      let coupon = null
      if (couponValid.code.length > 0) {
        const responseCouponVeri = await axiosClient.post(
          '/active-coupons',
          couponValid,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          },
        )

        coupon = {
          code: responseCouponVeri.data.code,
          coupon_id: responseCouponVeri.data.coupon_id,
          name: responseCouponVeri.data.name,
          discount: responseCouponVeri.data.discount,
        }
      }

      let orden = null
      if (coupon == null) {
        orden = {
          items,
          address_id: addresess_id,
          source: 'Efectivo',
        }
      } else {
        orden = {
          items,
          address_id: addresess_id,
          source: 'Efectivo',
          coupon,
        }
      }

      const responseOrden = await axiosClient.post('/orders', orden, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })

      const {status} = responseOrden

      if (status == 201 || status == 200) {
        dispatch({
          type: 'GET_ORDEN_OKAY_PAYMENT',
          payload: responseOrden.data,
        })

        dispatch({
          type: 'GET_ID_ADDRESS_GENERATED',
          payload: id,
        })
      }
    } catch (error) {
      console.log(error.response)
      swal('Hubo un problema en el servidor.', '', 'error')
    }
  }

  const getDeparments = async () => {
    try {
      const departments = await axiosClient.get(
        '/departments?filter=[{"method":"with","parameters":["municipalities"]}]',
      )

      dispatch({
        type: 'GET_DEPARMENTS_OKAY',
        payload: departments.data,
      })
    } catch (error) {
      console.log(error)
    }
  }

  const getMunicipalities = id => {
    if (id !== '0') {
      const deparment = deparments.filter(deparment => deparment.id == id)
      return deparment[0].municipalities ? deparment[0].municipalities : null
    }
  }

  const createOrder = async () => {
    try {
    } catch (error) {
      console.log(error)
    }
  }

  //async(id,name,number) => {
  const getProductsDiscountv2 = async number => {
    try {
      //const products = await axiosClient.get('/products?filter=[{"method":"with","parameters":["batches","batches.provider","batches.distributor"]},{"method":"with","parameters":["categories"]}]')
      //const products = await axiosClient.get('/products?filter=[{"method":"with","parameters":["category"]},{"method":"with","parameters":["batches","batches.provider","batches.distributor"]}]')
      let arr = {correlativo: number}
      const products = await axiosClient.get(
        `/products?filter=[{"method":"orderby","parameters":["id","asc"]},{"method":"with","parameters":["batches","batches.provider","batches.distributor","campaing"]},{"method":"paginate","parameters":["${number}"]}]`,
      )
      //console.log(products)
      const finalProducts = products.data.filter(
        product => product.batches.length > 0,
      )
      const conDescuento = finalProducts.filter(
        product =>
          product.batches[0].unit_price != product.batches[0].regular_price,
      )

      //const finalProducts = products.data.filter((product) => product.batches.length > 0)
      //const porFinProducts = finalProducts.filter((productStockYes) => productStockYes.batches[0].stock !== 0)
      //const conDescuento = porFinProducts.filter((product) => product.batches[0].unit_price != product.batches[0].regular_price )
      //console.log(porFinProducts)
      //console.log(conDescuento)

      dispatch({
        type: 'GET_PRODUCTS_DISCOUNT_OKAY',
        payload: conDescuento,
      })

      dispatch({
        type: 'GET_PRODUCTS_FREEDELIVERY_OKAY',
        payload: finalProducts,
        //payload: porFinProducts
      })

      dispatch({
        type: 'GET_CONTADOR_CATEGORIAS',
        payload: arr,
      })
    } catch (error) {
      console.log(error)
    }
  }

  const getProductsDiscount = async () => {
    try {
      //const products = await axiosClient.get('/products?filter=[{"method":"with","parameters":["batches","batches.provider","batches.distributor"]},{"method":"with","parameters":["categories"]}]')
      //const products = await axiosClient.get('/products?filter=[{"method":"with","parameters":["category"]},{"method":"with","parameters":["batches","batches.provider","batches.distributor"]}]')

      const products = await axiosClient.get(
        '/products?filter=[{"method":"orderby","parameters":["id","desc"]},{"method":"with","parameters":["batches","batches.provider","batches.distributor","campaing"]},{"method":"paginate","parameters":[100]}]',
      )
      //console.log(products)
      const finalProducts = products.data.filter(
        product => product.batches.length > 0,
      )
      const conDescuento = finalProducts.filter(
        product =>
          product.batches[0].unit_price != product.batches[0].regular_price,
      )

      //const finalProducts = products.data.filter((product) => product.batches.length > 0)
      //const porFinProducts = finalProducts.filter((productStockYes) => productStockYes.batches[0].stock !== 0)
      //const conDescuento = porFinProducts.filter((product) => product.batches[0].unit_price != product.batches[0].regular_price )
      //console.log(porFinProducts)
      //console.log(conDescuento)

      dispatch({
        type: 'GET_PRODUCTS_DISCOUNT_OKAY',
        payload: conDescuento,
      })

      dispatch({
        type: 'GET_PRODUCTS_FREEDELIVERY_OKAY',
        payload: finalProducts,
        //payload: porFinProducts
      })
    } catch (error) {
      console.log(error)
    }
  }

  const getProducts = async () => {
    try {
      //const products = await axiosClient.get('/products?filter=[{"method":"with","parameters":["batches","batches.provider","batches.distributor"]},{"method":"with","parameters":["categories"]}]')
      const products = await axiosClient.get(
        '/products?filter=[{"method":"with","parameters":["category"]},{"method":"with","parameters":["batches","batches.provider","batches.distributor"]}]',
      )

      //const products = await axiosClient.get('/products?filter=[{"method":"with","parameters":["batches","batches.provider","batches.distributor"]},{"method":"paginate","parameters":[100]}]')
      //console.log(products)
      const finalProducts = products.data.filter(
        product => product.batches.length > 0,
      )
      //const porFinProducts = finalProducts.filter((productStockYes) => productStockYes.batches[0].stock !== 0)
      //console.log(products)

      dispatch({
        type: 'GET_PRODUCTS_OKAY',
        payload: finalProducts,
        //payload: porFinProducts
      })
    } catch (error) {
      console.log(error)
    }
  }

  const getCategories = async () => {
    try {
      const categories = await axiosClient.get(
        'categories?filter=[{"method":"where","parameters":["parent",null]},{"method":"orderby","parameters":["priority","desc"]},{"method":"with","parameters":["subcategories"]}]',
      )

      dispatch({
        type: 'GET_CATEGORIES_OKAY',
        payload: categories.data,
      })
    } catch (error) {
      console.log(error)
      console.log('Problema al obtener las categorias')
    }
  }

  const getProductsByCategoryBussiness = (
    comercio,
    id,
    itemSelect,
    itemName,
    paginateOption,
  ) => {
    let parametersView = {
      paginate: paginateOption,
      countItem: products.length,
      itemSelect: itemSelect,
      itemName: itemName,
      itemID: id,
    }

    dispatch({
      type: 'GET_PRODUCTS_BY_CATEGORY_OKAY',
      payload: comercio,
      option: parametersView,
    })
  }
  const getProductsByCategoryBussinessSearch = (
    comercio,
    id,
    itemSelect,
    itemName,
    paginateOption,
  ) => {
    let parametersView = {
      paginate: paginateOption,
      countItem: products.length,
      itemSelect: itemSelect,
      itemName: itemName,
      itemID: id,
    }
    dispatch({
      type: 'GET_PRODUCTS_BY_SEARCH',
      payload: comercio,
      option: parametersView,
    })
  }
  const getProductsByCategoryBussinessProv = (
    comercio,
    id,
    itemSelect,
    itemName,
    paginateOption,
  ) => {
    let parametersView = {
      paginate: paginateOption,
      countItem: products.length,
      itemSelect: itemSelect,
      itemName: itemName,
      itemID: id,
    }
    dispatch({
      type: 'GET_PRODUCTS_BY_PROVIDER_OKAY',
      payload: comercio,
      option: parametersView,
    })
  }
  const getProductsByCategoryBussinessSubCate = (
    comercio,
    id,
    itemSelect,
    itemName,
    paginateOption,
  ) => {
    let parametersView = {
      paginate: paginateOption,
      countItem: products.length,
      itemSelect: itemSelect,
      itemName: itemName,
      itemID: id,
    }
    dispatch({
      type: 'GET_PRODUCTS_BY_SUB_CATEGORY_OKAY',
      payload: comercio,
      option: parametersView,
    })
  }

  const resetProductCategories = () => {
    dispatch({type: 'RESET_RELOAD_PRODUCTS_LIST'})
  }

  const resetProductSubCategories = () => {
    dispatch({type: 'RESET_RELOAD_PRODUCTS_SUB_LIST'})
  }

  const getProductsByCategory = async (
    id,
    itemSelect,
    itemName,
    paginateOption,
    orderList,
    min,
    max,
  ) => {
    //dispatch({ type: 'RESET_RELOAD_PRODUCTS_LIST' })

    try {
      StartLoadCount()
      //const response = await axiosClient.get(`/categories?filter=[{"method":"where","parameters":["id","${id}"]},{"method":"with","parameters":["products.category","products.batches","products.batches.provider","products.batches.distributor"]},{"method":"paginate","parameters":[1]}]`)
      //const response = await axiosClient.get(`products?filter=[{"method":"where","parameters":["category_id","${id}"]},{"method":"orderby","parameters":["id","desc"]},{"method":"with","parameters":["batches","batches.provider","batches.distributor","campaing","categories"]},{"method":"paginate","parameters":["${number}"]}]`)
      const response = await axiosClient.get(
        `products?filter=[{"method":"orderby","parameters":["id","desc"]},{"method":"with","parameters":["batches","batches.provider","batches.distributor","provider","campaing"]},{"method":"join","parameters":["category_product","category_product.product_id","=","products.id"]},{"method":"whereIn","parameters":["category_product.category_id",["${id}"]]},{"method":"paginate","parameters":["${paginateOption}"]}]`,
      )
      console.log(response);
      const products = response.data.filter(
        product =>
          (product.batches.length > 0) & (product.batches.deleted_at == null),
      )

      let productolist = []
      let items = []
      let itemsList = []
      let itemPriceRange = []

      if (orderList >= 0) {
        products.forEach(element => {
          element.batches.forEach(elementBatches => {
            items.push(elementBatches)
          })
        })

        switch (orderList) {
          case '1':
            itemsList = items.sort(
              (a, b) => parseFloat(a.unit_price) - parseFloat(b.unit_price),
            )
            break
          case '2':
            itemsList = items.sort(
              (a, b) => parseFloat(b.unit_price) - parseFloat(a.unit_price),
            )
            break
          case '3':
            itemsList = items.sort((a, b) => {
              const aDate = new Date(a.created_at)
              const bDate = new Date(b.created_at)

              return bDate.getTime() - aDate.getTime()
            })
            break
          case '4':
            itemsList = items.sort((a, b) => {
              const aDate = new Date(a.created_at)
              const bDate = new Date(b.created_at)

              return aDate.getTime() - bDate.getTime()
            })
            break
          default:
            productolist = products
            itemsList = items
            break
        }

        if (min >= 0 && max > 0) {
          if (max > min) {
            itemPriceRange = itemsList.filter(
              batches =>
                parseFloat(batches.unit_price) >= parseFloat(min) &&
                parseFloat(batches.unit_price) <= parseFloat(max),
            )
            //console.log(itemPriceRange)
          }
        }

        if (itemPriceRange.length == 0) {
          itemsList.forEach(element => {
            products.forEach(elementPrincipal => {
              if (elementPrincipal.id == element.product_id) {
                if (productolist.indexOf(elementPrincipal) == -1) {
                  productolist.push(elementPrincipal)
                }
              }
            })
          })
        } else {
          productolist = []
          itemPriceRange.forEach(element => {
            products.forEach(elementPrincipal => {
              if (elementPrincipal.id == element.product_id) {
                if (productolist.indexOf(elementPrincipal) == -1) {
                  productolist.push(elementPrincipal)
                }
              }
            })
          })
        }
      }
      //console.log("MIGUEL CONTEXT",products.length);

      let parametersView = []

      if (paginateOption <= products.length) {
        parametersView = {
          paginate: paginateOption,
          countItem: products.length,
          itemSelect: itemSelect,
          itemName: itemName,
          itemID: id,
          finally: 1,
        }
      } else {
        parametersView = {
          paginate: paginateOption,
          countItem: products.length,
          itemSelect: itemSelect,
          itemName: itemName,
          itemID: id,
          finally: 0,
        }
      }

      //console.log(parametersView)

      dispatch({
        type: 'GET_PRODUCTS_BY_CATEGORY_OKAY',
        payload: productolist,
        option: parametersView,
      })
    } catch (error) {
      FinishLoadCount()
      console.log(error)
    } finally {
      FinishLoadCount()
    }
  }

  /*    const getProductsByCategory = async (id,category) => {
                dispatch({ type: 'RESET_RELOAD_PRODUCTS_LIST'})

                
                try {
                    const response = await axiosClient.get(`/categories?filter=[{"method":"where","parameters":["id","${id}"]},{"method":"with","parameters":["products.category","products.batches","products.batches.provider","products.batches.distributor"]}]`)
                    console.log('Id de la categoria ---->  '+ id)
                    console.log('Nombre de la categoria ---->  '+ category.name)
                    const products = response.data[0].products.filter((product) => product.batches.length > 0)            
                    console.log(products)
                    console.log('categorias **************')
                    console.log(category)
                    dispatch({
                        type: 'GET_PRODUCTS_BY_CATEGORY_OKAY',
                        payload: {pro:products,cat: category}
                    })
                    
                } catch (error) {
                    console.log(error)
                }
            }*/

  const getProductById = async id => {
    try {
      const response = await axiosClient.get(
        `/products?filter=[{"method":"with","parameters":["batches","batches.distributor","provider","campaing"]},{"method":"where","parameters":["id",${id}]}]`,
      )
      const idProvider = response.data[0].provider_id
      const productsRelated = await axiosClient.get(
        `/products?filter=[{"method":"where","parameters":["provider_id",${idProvider}]},{"method":"with","parameters":["batches","batches.provider","batches.distributor","campaing"]}]`,
      )
      
      const productImages = response.data[0].images
      const imagesSplit = productImages.split('"')
      const imagesArray = imagesSplit.filter(image => image.includes('http'))
      
      dispatch({
        type: 'GET_IMAGES_OF_PRODUCT',
        payload: imagesArray
      })
      dispatch({
        type: 'GET_PRODUCT_BY_ID_OKAY',
        payload: response.data[0],
      })
      dispatch({
        type: 'GET_PRODUCTS_RELATED_OKAY',
        payload: productsRelated.data
      })

    } catch (error) {}
  }

  const addProductToCarShopping = product => {  
    const newProduct = {}
    newProduct.name = product.name
    newProduct.talla = product.talla
    newProduct.color = product.color
    newProduct.image_url = product.image_url
    newProduct.id = product.id
    newProduct.batches = product.batches
    newProduct.cantidadCli = product.cantidadCli
    newProduct.id_special = uuidv4()
    if(product.promo_price) {
      newProduct.batches[0].regular_price = product .promo_price
      newProduct.batches[0].unit_price = product.promo_price
      newProduct.batches[0].unit_price_real = product.promo_price
      newProduct.batches[0].regular_price_real = product.promo_price
    }

    const productExists = state.carShopping.filter(productInCar => productInCar.id === newProduct.id)[0]
    if(productExists) {
      const carShoppingCleaned = state.carShopping.filter(productFiltered => productFiltered.id !== productExists.id)
      newProduct.cantidadCli += productExists.cantidadCli 
      carShoppingCleaned.push(newProduct)
      
      dispatch({type: 'INCREMENT_ONE_PRODUCT', payload: carShoppingCleaned})
      swal('Producto agregado al carrito!', '', 'success')
      return
    }

    dispatch({
      type: 'ADD_PRODUCT_TO_CAR_SHOPPING',
      payload: newProduct,
    })
    swal('Producto agregado al carrito!', '', 'success')
  }

  const addProductToCarShoppingById = (id, products) => {
    //cleanDeliveryInfo()

    const product = products.filter(product => product.id === id)

    dispatch({
      type: 'ADD_PRODUCT_TO_CAR_SHOPPING',
      payload: product[0],
    })

    swal('Producto agregado al carrito!', '', 'success')
  }

  const deleteProductFromCarShopping = id => {
    cleanDeliveryInfo()
    dispatch({
      type: 'DELETE_PRODUCT_CAR_SHOPPING',
      payload: id,
    })
  }

  const getUserInformation = user => {
    try {
      dispatch({
        type: 'GET_USER_INFORMATION_OKAY',
        payload: user,
      })

      getAddress(user)
    } catch (error) {}
  }

  const getAddressesClient = async () => {
    const {token} = user
    try {
      const addresses = await axiosClient.get('/addresses/3', {
        auth: {
          type: 'bearer',
          bearer: {
            token,
          },
        },
      })
    } catch (error) {
      console.log(error)
    }
  }

  const getProductsBySearch = async name => {
    dispatch({type: 'RESET_SEARCH_PRODUCS'})

    try {
      var filtro = name

      const products = await axiosClient.get(
        `/products?filter=[{"method":"with","parameters":["provider","batches","campaing"]},{"method":"where","parameters":["products.name","like","%${filtro}%"]},{"method":"orWhere","parameters":["products.description","like","%${filtro}%"]},{"method":"orWhere","parameters":["products.name","=","${filtro}"]}]`,
      )
      //console.log("ENTRO1")
      //console.log(products)
      if (products.data.length <= 0) {
        products = null
        filtro = name.replace(' ', '')
        //console.log("ENTRO")
        products = await axiosClient.get(
          `/products?filter=[{"method":"with","parameters":["provider","batches","campaing"]},{"method":"where","parameters":["products.name","like","%${filtro}%"]},{"method":"orWhere","parameters":["products.description","like","%${filtro}%"]}]`,
        )
      }

      const productsFixed = products.data.filter(
        product => product.batches.length !== 0,
      )

      //console.log(productsFixed)

      dispatch({
        type: 'GET_PRODUCTS_BY_SEARCH',
        payload: productsFixed,
      })
    } catch (error) {
      console.log(error.response)

      try {
        var filtroConEspacio = ' ' + name.replace(' ', '').toLowerCase()
        const products = await axiosClient.get(
          `/products?filter=[{"method":"with","parameters":["provider","batches","campaing"]},{"method":"where","parameters":["products.name","like","%${filtroConEspacio}%"]},{"method":"orWhere","parameters":["products.description","like","%${filtroConEspacio}%"]}]`,
        )

        const productsFixed = products.data.filter(
          product => product.batches.length !== 0,
        )

        //console.log(productsFixed)

        dispatch({
          type: 'GET_PRODUCTS_BY_SEARCH',
          payload: productsFixed,
        })
      } catch (error) {
        dispatch({
          type: 'GET_PRODUCTS_BY_SEARCH_ERROR',
        })
      }
    }

    // let fixedName = name.toUpperCase()
    // const productsGetting = products.filter(product => String(product.name).startsWith(fixedName))
  }

  const setCategoryShowClose = () => {
    dispatch({
      type: 'CLOSE_CATEGORY_BAR',
    })
  }

  const setCategoryShowOpen = () => {
    dispatch({
      type: 'OPEN_CATEGORY_BAR',
    })
  }

  const signOut = () => {
    dispatch({type: 'SIGN_OUT_SESSION'})
  }

  /* 
            const initCategories = () => API.get('categories')
                .then(response => dispatch({ type: "SET_CATEGORIES", payload: response.data }))

            const initHomeProducts = () => {
                API.get('/products?filter=[{"method":"with","parameters":["batches","category"]}]')
                .then(response => {
                    const _data = response.data
                    shuffle(_data)
                    dispatch({ type: "SET_HOME_PRODUCTS", payload: _data})
                })
            }        
        */

  const paymentWithCreditCard = async (cardInfo, couponValid) => {
    dispatch({
      type: 'RESET_ERROR_CARD_MSG',
    })

    const {
      cardName,
      cardNumber,
      cvv_card,
      expiration_card_year,
      expiration_month,
    } = cardInfo
    const addresess_id = deliveryInfo[0].address_id
    const {token} = user

    let coupon = null
    if (couponValid.code.length > 0) {
      const responseCouponVeri = await axiosClient.post(
        '/active-coupons',
        couponValid,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      )

      coupon = {
        code: responseCouponVeri.data.code,
        coupon_id: responseCouponVeri.data.coupon_id,
        name: responseCouponVeri.data.name,
        discount: responseCouponVeri.data.discount,
      }
    }

    const items = carShopping.map(product => {
      const id = product.batches[0].id
      let item = {
        quantity: product.cantidadCli,
        batch_id: id,
      }
      return item
    })

    let bodyCardPayment = null

    if (coupon == null) {
      bodyCardPayment = {
        items,
        source: 'Tarjeta',
        address_id: addresess_id,
        card: {
          name: cardName,
          number: cardNumber,
          cvv: cvv_card,
          expiration_year: expiration_card_year,
          expiration_month: expiration_month,
        },
      }
    } else {
      bodyCardPayment = {
        items,
        source: 'Tarjeta',
        address_id: addresess_id,
        coupon,
        card: {
          name: cardName,
          number: cardNumber,
          cvv: cvv_card,
          expiration_year: expiration_card_year,
          expiration_month: expiration_month,
        },
      }
    }

    //console.log(bodyCardPayment)

    try {
      const response = await axiosClient.post(
        '/orders/credit',
        bodyCardPayment,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      )

      //console.log(response)

      const {status} = response
      if (status == 200 || status == 201) {
        dispatch({
          type: 'GET_ORDEN_OKAY_PAYMENT',
          payload: response.data,
        })
      }
    } catch (error) {
      console.log(error.response)

      dispatch({
        type: 'GET_ORDEN_ERROR_CARD',
        payload: error.response.data.error,
      })
    }
  }

  const cleanDeliveryInfo = () => {
    dispatch({
      type: 'CLEAN_DELIVERY_INFO',
    })
    dispatch({
      type: 'CLEAN_ID_ADDRESS_GENERATED',
    })
  }

  const resetRealoadProductsByCategory = () => {
    dispatch({
      type: 'RESET_FALSE_RELOAD_PRODUCTS_BY_CATEGORY',
    })
  }

  const getProductsByProviderID = async (id, number) => {
    dispatch({
      type: 'CLEAN_PRODUCTS_BY_PROVIDER',
    })

    console.log('ENTRO', id)
    let arr = {correlativo: number, id: id}

    try {
      const products = await axiosClient.get(
        `/products?filter=[{"method":"where","parameters":["provider_id",${id}]},{"method":"with","parameters":["batches","batches.provider","batches.distributor","campaing"]}]`,
      )
      const finalProducts = products.data.filter(
        product => product.batches.length > 0,
      )
      const porFinProducts = finalProducts.filter(
        productStockYes => productStockYes.batches[0].deleted_at == null,
      )

      let marca = porFinProducts[0].batches[0].provider?.name

      dispatch({
        type: 'GET_PRODUCTS_BY_PROVIDERS_OKAY',
        payload: porFinProducts,
        option: marca,
      })

      dispatch({
        type: 'GET_CONTADOR_CATEGORIAS',
        payload: arr,
      })
    } catch (error) {
      console.log(error.response)
    }
  }

  const getProductsByProviderAndCategory = async (categoryID, providerID) => {
    dispatch({
      type: 'CLEAN_PRODUCTS_BY_PROVIDER',
    })

    try {
      const products = await axiosClient.get(
        `/products?filter=[{"method":"where","parameters":["category_id",${categoryID}]},{"method":"where","parameters":["provider_id",${providerID}]},{"method":"with","parameters":["batches","batches.provider","batches.distributor"]}]`,
      )
      const finalProducts = products.data.filter(
        product => product.batches.length > 0,
      )
      //const porFinProducts = finalProducts.filter((productStockYes) => productStockYes.batches[0].stock !== 0)

      if (finalProducts.length === 0) {
        dispatch({
          type: 'GET_PRODUCTS_BY_PROVIDER_AND_CATEGORY_EMPTY',
        })

        setTimeout(() => {
          getProductsByProviderID(providerID, 50)
        }, 3000)
        return
      } else {
        dispatch({
          type: 'GET_PRODUCTS_BY_PROVIDER_AND_CATEGORY',
          payload: finalProducts,
          //payload: porFinProducts
        })
      }
    } catch (error) {
      console.log(error.response)
    }
  }

  const cleanNameOfProvider = () => {
    dispatch({
      type: 'CLEAN_NAME_PROVIDER',
    })
  }

  const getSubCategories = (id, categories) => {
    try {
      dispatch({
        type: 'GET_SUB_CATEGORIES_OKAY',
        payload: categories,
      })
    } catch (error) {
      console.log(error.response)
    }
  }

  const getAllProviders = async () => {
    try {
      const AllProviders = await axiosClient.get(
        'providers?filter=[{"method":"where","parameters":["visible",1]},{"method":"orderby","parameters":["id","desc"]},{"method":"with","parameters":["batches"]}]',
      )
      const finalTopProviders = AllProviders.data.filter(
        product => product.batches.length > 0,
      )

      dispatch({
        type: 'GET_ALL_PROVIDERS_OKAY',
        payload: finalTopProviders,
      })
    } catch (error) {}
  }

  const getProductsBySubCategory = async (
    id,
    itemSelect,
    itemName,
    paginateOption,
    orderList,
    min,
    max,
  ) => {
    dispatch({type: 'RESET_FALSE_RELOAD_PRODUCTS_BY_CATEGORY'})
    StartLoadCount()
    try {
      //const products = await axiosClient.get(`/products?filter=[{"method":"select","parameters":["products.*"]},{"method":"with","parameters":["batches","batches.provider","batches.distributor", "provider","campaing"]},{"method":"join","parameters":["category_product","category_product.product_id","=","products.id"]},{"method":"whereIn","parameters":["category_product.category_id",[${id}]]},{"method":"with","parameters":["category"]},{"method":"paginate","parameters":["${number}"]}]`)
      const products = await axiosClient.get(
        `products?filter=[{"method":"orderby","parameters":["id","desc"]},{"method":"with","parameters":["batches","batches.provider","batches.distributor","provider","campaing"]},{"method":"join","parameters":["category_product","category_product.product_id","=","products.id"]},{"method":"whereIn","parameters":["category_product.category_id",["${id}"]]},{"method":"paginate","parameters":["${paginateOption}"]}]`,
      )
      const finalProducts = products.data.filter(
        product => product.batches.length > 0,
      )
      const porFinProducts = finalProducts.filter(
        productStockYes => productStockYes.batches[0].stock !== 0,
      )

      //console.log(porFinProducts)

      let parametersView = {
        paginate: paginateOption,
        //"countItem":    finalProducts.length,
        countItem: porFinProducts.length,
        itemSelect: itemSelect,
        itemName: itemName,
        itemID: id,
      }

      let productolist = []
      let items = []
      let itemsList = []
      let itemPriceRange = []

      if (orderList >= 0) {
        porFinProducts.forEach(element => {
          element.batches.forEach(elementBatches => {
            items.push(elementBatches)
          })
        })

        //finalProducts.forEach(element => {

        //element.batches.forEach(elementBatches => {
        //items.push(elementBatches);
        //})
        //})

        switch (orderList) {
          case '1':
            itemsList = items.sort(
              (a, b) => parseFloat(a.unit_price) - parseFloat(b.unit_price),
            )
            break
          case '2':
            itemsList = items.sort(
              (a, b) => parseFloat(b.unit_price) - parseFloat(a.unit_price),
            )
            break
          case '3':
            itemsList = items.sort((a, b) => {
              const aDate = new Date(a.created_at)
              const bDate = new Date(b.created_at)

              return bDate.getTime() - aDate.getTime()
            })
            break
          case '4':
            itemsList = items.sort((a, b) => {
              const aDate = new Date(a.created_at)
              const bDate = new Date(b.created_at)

              return aDate.getTime() - bDate.getTime()
            })
            break
          default:
            //productolist = finalProducts
            productolist = porFinProducts
            itemsList = items
            break
        }

        if (min >= 0 && max > 0) {
          if (max > min) {
            itemPriceRange = itemsList.filter(
              batches =>
                parseFloat(batches.unit_price) >= parseFloat(min) &&
                parseFloat(batches.unit_price) <= parseFloat(max),
            )
          }
        }

        if (itemPriceRange.length == 0) {
          itemsList.forEach(element => {
            //finalProducts.forEach(elementPrincipal => {
            //if(elementPrincipal.id==element.product_id){
            //if(productolist.indexOf(elementPrincipal) == -1 ){
            //productolist.push(elementPrincipal)
            //}
            //}
            //})

            porFinProducts.forEach(elementPrincipal => {
              if (elementPrincipal.id == element.product_id) {
                if (productolist.indexOf(elementPrincipal) == -1) {
                  productolist.push(elementPrincipal)
                }
              }
            })
          })
        } else {
          productolist = []
          itemPriceRange.forEach(element => {
            //finalProducts.forEach(elementPrincipal => {
            //if(elementPrincipal.id==element.product_id){
            //if(productolist.indexOf(elementPrincipal) == -1 ){
            //productolist.push(elementPrincipal)
            //}

            //}

            //})

            porFinProducts.forEach(elementPrincipal => {
              if (elementPrincipal.id == element.product_id) {
                if (productolist.indexOf(elementPrincipal) == -1) {
                  productolist.push(elementPrincipal)
                }
              }
            })
          })
        }
      }

      dispatch({
        type: 'GET_PRODUCTS_BY_SUB_CATEGORY_OKAY',
        payload: productolist,
        option: parametersView,
      })
    } catch (error) {
      console.log(error.response)
      FinishLoadCount()
    } finally {
      FinishLoadCount()
    }
  }

  const cleanProductsBySubCategory = () => {
    dispatch({
      type: 'CLEAN_PRODUCTS_BY_SUB_CATEGORY',
    })
  }

  const getAddress = async user => {
    //const { token } = user

    try {
      const address = await axiosClient.get(
        '/addresses?filter=[{"method":"orderBy","parameters":["id","DESC"]},{"method":"with","parameters":["city"]}]',
        {
          headers: {
            Authorization: `Bearer ${user.token}`,
          },
        },
      )

      dispatch({
        type: 'GET_ADDRESS_OKAY',
        payload: address.data,
      })
    } catch (error) {
      console.log(error)
    }
  }

  const getUserAddress = userAddress => {
    try {
      dispatch({
        type: 'GET_USER_ADDR_OKAY',
        payload: userAddress,
      })
    } catch (error) {}
  }

  const getIdAddressGenerated = idAddressGenerated => {
    try {
      dispatch({
        type: 'GET_ID_ADDRESS_GENERATED',
        payload: idAddressGenerated,
      })
    } catch (error) {}
  }

  const cleanIdAddressGenerated = () => {
    dispatch({
      type: 'CLEAN_ID_ADDRESS_GENERATED',
    })
  }

  const setPaginateCount = val => {
    dispatch({
      type: 'GET_PAGINATE_COUNT',
      payload: val,
    })
  }

  const cleanPaginateCount = () => {
    dispatch({
      type: 'CLEAN_PAGINATE_COUNT',
    })
  }
  const StartLoadCount = () => {
    dispatch({
      type: 'GET_LOAD',
    })
  }

  const FinishLoadCount = () => {
    dispatch({
      type: 'CLEAR_LOAD',
    })
  }
  const CountProductLoad = val => {
    dispatch({
      type: 'GET_COUNT_PRODUCT',
      payload: val,
    })
  }

  const ClearProductLoad = () => {
    dispatch({
      type: 'CLEAR_COUNT_PRODUCT',
    })
  }
  return (
    <ContextApp.Provider
      value={{
        /* States */
        products: state.products,
        productsDiscount: state.productsDiscount,
        productsFreeDelivery: state.productsFreeDelivery,
        categories: state.categories,
        productsByCategory: state.productsByCategory,
        singleProduct: state.singleProduct,
        carShopping: state.carShopping,
        deparments: state.deparments,
        productsBySearch: state.productsBySearch,
        user: state.user,
        categoryListShow: state.categoryListShow,
        orderCreated: state.orderCreated,
        redirectSuccess: state.redirectSuccess,
        deliveryInfo: state.deliveryInfo,
        errorCardPaymentMsg: state.errorCardPaymentMsg,
        searchDone: state.searchDone,
        reloadProductsByCategory: state.reloadProductsByCategory,
        productsByProvider: state.productsByProvider,
        provider_name: state.provider_name,
        products_not_found: state.products_not_found,
        productsToShowInHome: state.productsToShowInHome,
        productsToShowInHome2: state.productsToShowInHome2,
        productsToShowInHome3: state.productsToShowInHome3,
        productsToShowInHomeTec: state.productsToShowInHomeTec,
        productsToShowInHomeBel: state.productsToShowInHomeBel,
        productsToShowInHomeMod: state.productsToShowInHomeMod,
        productsToShowInHomeHog: state.productsToShowInHomeHog,
        subCategoriesList: state.subCategoriesList,
        productsBySubCategory: state.productsBySubCategory,
        parametersView: state.parametersView,
        paginate: state.paginate,
        paginateCount: state.paginateCount,
        contador: state.contador,
        userAddress: state.userAddress,
        userAddr: state.userAddr,
        idAddressGenerated: state.idAddressGenerated,
        topProviders: state.topProviders,
        allProviders: state.allProviders,
        loading: state.loading,
        countProduct: state.countProduct,
        searchError:state.searchError,
        productsRelatedFromOne: state.productsRelatedFromOne,
        singleProductsImages: state.singleProductsImages,
        cancelSpinner: state.cancelSpinner,
        /* Methods */
        getProductsToShowInHome,
        getProductsByCategory,
        getProductsByCategoryBussiness,
        getProductsByCategoryBussinessSubCate,
        getProductsByCategoryBussinessProv,
        getProductsByCategoryBussinessSearch,
        getProductById,
        addProductToCarShopping,
        deleteProductFromCarShopping,
        getUserInformation,
        getAddressesClient,
        addProductToCarShoppingById,
        getMunicipalities,
        createOrder,
        saveAddresses,
        getProductsBySearch,
        setCategoryShowOpen,
        setCategoryShowClose,
        cleanCarShoppingAll,
        createOrderFinally,
        signOut,
        paymentWithCreditCard,
        cleanDeliveryInfo,
        resetRealoadProductsByCategory,
        getProductsByProviderID,
        getProductsByProviderAndCategory,
        cleanNameOfProvider,
        getSubCategories,
        getProductsBySubCategory,
        cleanProductsBySubCategory,
        getProductsDiscount,
        getProductsDiscountv2,
        getAddress,
        getUserAddress,
        getIdAddressGenerated,
        cleanIdAddressGenerated,
        getAllProviders,
        setPaginateCount,
        cleanPaginateCount,
        StartLoadCount,
        FinishLoadCount,
        CountProductLoad,
        ClearProductLoad,
        resetProductCategories,
        resetProductSubCategories,
      }}
    >
      {' '}
      {children}{' '}
    </ContextApp.Provider>
  )
}

export default StateApp
